/**
 * NOTE: For compatibility across platforms all calls **must** return a
 * `Promise` object!
 */

import { PlatformMessage } from '@reachmedianetwork/post-message-client-rds-api';
import { PlayerPmc } from '../PlayerPmc';

export interface ScreenOrientationInterface {
    /**
     * Rotate the screen
     */
    setOrientation(orientation: 'Default' | 'Clockwise90' | 'Clockwise270'): Promise<void>;
}

export function supportsScreenOrientation(
    platform: unknown
): platform is ScreenOrientationInterface {
    if (platform instanceof PlayerPmc) {
        return platform.supportsMessage(PlatformMessage.ScreenConfigurationSet);
    }
    return platform instanceof Object && 'setOrientation' in platform;
}
